/**
 * IM消息列表
 * author: jiaheming
 * date: 2019/06/12
 */
import React from 'react';
import styled from 'styled-components';
import empty from '../../static/images/empty_m.png';
import IMFooter from './IMFooter';

const IMEmpty_style = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    .improve-info {
        display: block;
        width: 68px;
        height: 15px;
        font-size: 15px;
        font-weight: 400;
        color: rgba(103, 189, 122, 1);
        line-height: 15px;
        margin: 16px auto;
    }
`;

const EmptyImg_style = styled.img`
    display: block;
    width: 100px;
    height: 85px;
    margin: 221px auto 17px auto;
`;

const EmptyText1_style = styled.div`
    width: 131px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
    margin: 4px auto;
`;

const EmptyText2_style = styled.div`
    width: 176px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(108, 111, 128, 1);
    line-height: 17px;
    margin: 0 auto;
    text-align: center;
`;

export default function IMEmpty(props) {
    return (
        <IMEmpty_style>
            <EmptyImg_style src={empty} />
            <EmptyText1_style>您还没有对话信息</EmptyText1_style>
            <EmptyText2_style>完善你的个人信息，让更多客户看到你的专业</EmptyText2_style>
            <a className="improve-info" href="javascript:;" onClick={props.improveInfoCallback}>
                点击完善
            </a>
            <IMFooter />
        </IMEmpty_style>
    );
}
